import { makeStyles } from '@alpha/ui-lib/theme';

const useStyles = makeStyles(
  () => ({
    button: {
      minWidth: 0,
      width: 60,
      height: 60,
      fontSize: '18px',
    },
  }),
  { name: 'HeaderButtons' },
);

export default useStyles;
